import { cn } from 'src/lib/utils'

const ErrorMessage = ({ message, className }: { message: string; className?: string }) => {
  return <div className={cn('font-montserrat font-[12px] text-danger', className)}>{message}</div>
}

export default ErrorMessage
